module.exports = __webpack_public_path__ + "img/medicine2.e3dcbc5f.jpg";